// extracted by mini-css-extract-plugin
export default {"button":"nO26dh"};